import useRouter from 'hooks/useRouter';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import EnergyBillListView from '../../components/EnergyBillListView';

EnergyBillListScreen.propTypes = {};

function EnergyBillListScreen(props) {
  // MARK: ---- PROPERTIES ----
  const { user } = useSelector((state) => state.auth);
  const router = useRouter();
  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = router.pathname;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);

  return (
    <div className="px-4 my-4">
      <EnergyBillListView prefKey={prefKey} />
    </div>
  );
}

export default EnergyBillListScreen;
